import { th } from "date-fns/locale"
import { TableShimmer } from "../../../ShimmerUI"
import NotFound from "../../../Notfound"

type Column = {
  header: string
  accessor?: string
  render?: (row: any) => React.ReactNode
}
type ReusableTableProps = {
    columns : Column []
    data?:any[]
    loading?:boolean
}
const ReusableTable = ({columns,data,loading}:ReusableTableProps) =>{
    return(
        <div className="overflow-hidden bg-white rounded-lg shadow">
            <div className="overflow-x-auto">
                <table className="min-w-full">
                    {/* HEADER */}
                    <thead>
                        <tr className="text-sm text-left text-white uppercase bg-[#5BC0BE]">
                            {columns.map((col, index)=>(
                               <th key={index} className='px-6 py-3'>
                                {col.header}
                               </th>
                            ))}
                        </tr>
                    </thead>
                    {/* BODY */}
                    <tbody>
                        {loading ? (
                            <TableShimmer columns={columns.length}/>
                        ) : data?.length === 0 ? (
                            <tr>
                            <td colSpan={columns.length} className="p-4 text-center">
                                <NotFound/>
                            </td>
                            </tr>
                        ) : (
                            data?.map((row, rowIndex) => (
                                <tr
                                    key={row._id || row.id || rowIndex}
                                    className="hover:bg-gray-50"
                                >
                                    {columns.map((col, colIndex) => (
                                        <td key={colIndex} className="px-6 py-4">
                                            {col.render ? col.render(row) : row[col.accessor as keyof typeof row] || "NA"}
                                        </td>
                                    ))}
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )
}
export default ReusableTable